<template>
  <div>
    <van-nav-bar 
    left-text="返回"
          left-arrow
          fixed
          @click-left="goHome"
          
      style="position:fixed;width:100%">
        <template #title>
          <span>直接收料</span>
        </template>
      </van-nav-bar>

    <van-row style="padding-top:60px">
        <van-form ref="checkbox">
          <van-cell-group inset>
            <van-field
              v-model="supplier.name"
              name="供应商"
              label="供应商"
              placeholder="供应商"
              disabled
            >
              <template #button>
                <van-icon name="contact" size="24" @click="$refs.supplierSelectDialog.open()" style="font-size:24px;color:#0D79C4" />
                <van-icon name="scan" size="24" @click="scanSupplier" style="font-size:24px;color:#FAC20D"/>
              </template>
            </van-field>

            <van-field
              v-model="productId"
              name="品号"
              label="品号"
              placeholder="品号"
              
            >
              <template #button>
                <van-icon name="search" size="24" @click="searchProduct" style="font-size:24px;color:#0D79C4"/>
                <van-icon name="scan" size="24" @click="scanProduct" style="font-size:24px;color:#FAC20D"/>
              </template>
            </van-field>

            <van-field
              v-model="productName"
              name="品名"
              label="品名"
              disabled 
              placeholder=""
              clearable
            >
            </van-field>

            <van-field
                v-model="count"
                name="数量"
                label="数量"
                placeholder="数量"
                clearable
              >
                <template #button>
                  <van-icon name="add" size="24" @click="addCount" style="font-size:24px"/>
                </template>
              </van-field>
          </van-cell-group>
        </van-form>
      </van-row>

      <van-row style="padding-top:10px">
          <van-list  
            style="overflow: scroll;padding:0 20px;overflow-y: auto;"
            :style="{ height:innerHeight}"
          >
              <van-cell v-for="(item,index) in filterProduct" :key="index" title="" style="margin:10px 0" :class="item.select?'select':'unselect'">
                <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                <template #label>
                  <div @click="selectItem(item)" >
                    <van-row >
                      <div class="content">
                        <van-col span="24">{{ item.productName }}【{{item.productId}}】</van-col>
                        
                        <van-col span="16" style="margin-top:4px">
                          采购单号:{{item.orderId}}
                        </van-col>
                        <van-col span="8" style="margin-top:4px">
                          序号:{{item.index }}
                        </van-col>
                        <van-col span="24" style="margin-top:4px">
                          待办:{{item.leftCount}}
                        </van-col>
                        <van-col span="24" style="margin-top:4px">
                          已扫:
                          <span v-if="!item.editing"> {{item.submitCount || 0}} </span>
                          <input type="text" pattern="[0-9]+"  v-else v-model="eidtItemCount"/>
                          <span v-if="item.scaned" style="float:right;color:red">已扫</span>
                         <!-- <van-field v-model="eidtItemCount" type="number" label="数字" v-else/>-->
                        </van-col>
                      </div>
                    </van-row>
                    <van-row>
                      <van-col span="24" style="height:20px" v-if="!item.editing">
                        <span style="position:absolute;color:#1989fa;right:16px;" @click.stop="updateCount(item)">修改</span>
                        <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:42px;" name="edit" size="16" color="#1989fa"/>
                      </van-col>
                      <van-col span="24" style="height:20px" v-else>
                        <span style="position:absolute;color:#1989fa;right:80px;" @click.stop="confirmUpdateCount(item)">确定</span>
                        <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:102px;" name="success" size="16" color="#1989fa"/>
                        <span style="position:absolute;color:#1989fa;right:16px;" @click.stop="cancelUpdateCount(item)">取消</span>
                        <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:42px;" name="cross" size="16" color="red"/>
                      </van-col>

                    </van-row>
                  </div>
                </template>
            </van-cell>
           
        </van-list>
      </van-row>

      <van-row style="padding:20px">
          <van-button round   size="large" type="info" @click="submit" style="height:30px;" :disabled="!(supplier.id != null && supplier.id !='')">提交</van-button>
      </van-row>
      
    <SuppliersSelectDialog
      isSingle = true
      ref="supplierSelectDialog"
      @select="
        (data) => {
          updateSupplier(data);
          $forceUpdate();
        }
      "
    ></SuppliersSelectDialog>

  </div>
</template>
  
  <script>
import Vue from 'vue'
import { router }  from '../../../router'
import qywxUtil from '../../../util/jweixin/index'
import { getDetail,submit } from '../../../api/wms/materialReceive/index'
import { Toast,Dialog } from 'vant';
import { getSuppliers } from '../../../api/wms/index'

export default {
    components: {

    },
    computed: {
    },
    data() {
      return {
        innerHeight:window.innerHeight - 330 + 'px',
        supplier:{
          name:'',
          id:null
        },
        productId:'',
        productName:'',
        count:null,
        eidtItemCount:0,
        selectedItem:null,
        list:[]
      };
    },
    computed:{
      filterProduct(){
        return this.list;
      }
    },
    mounted(){
      if('development' != process.env.NODE_ENV)
      qywxUtil.init();
    },
    methods: {
      initialData(){
       
        this.productId = '';
        this.productName = '';
        this.count = null;
        this.eidtItemCount = 0;
        this.selectedItem = null;
        this.list = [];
      },
      updateSupplier(data){
        if(data.id == this.supplier.id){
          return;
        }

        //初始化数据
        this.initialData();
        this.supplier = data;
        this.getDetail();
      },
      initialProductItemInfo(){
        //如果当前已选择一个，则过滤
        this.productName = '';
        this.count = 0;

        //1、查找品号对应品名
        var productList = this.list.filter(o=> o.productId == this.productId);
        if(productList.length > 0) 
          this.productName = productList[0].productName;
        else{
          this.productId = '';
          this.count = null;
          //取消选中的焦点
          this.list.forEach(o=>{
            delete o.select;
          });
          this.$forceUpdate();
          return;
        }
          

        //2、如果有选中则默认带出剩余数量,同时品号也相同
        if(this.selectedItem != null && this.selectedItem.productId == this.productId){
          this.count = Math.max(0,parseFloat(this.selectedItem.leftCount)  - parseFloat(this.selectedItem.submitCount )  ) ;
        }
        else{
          this.list.forEach(o=>{
            delete o.select;
          });

          //找出第一个匹配当前品号的选中
          var selectProduct = this.filterProduct.filter(o=> o.productId == this.productId);
          if(selectProduct.length >= 1){
            selectProduct[0].select =  'select';
            this.selectedItem = selectProduct[0];
            this.count = Math.max(0, parseFloat(this.selectedItem.leftCount)  - parseFloat(this.selectedItem.submitCount ))  ;
          }
          
        }

        //如果当前选择的与品号不同，默认选择第一个相同的品号
        this.list.sort((a,b)=>{
          var oa = a.select?1:0;
          var ob = b.select?1:0;
          var result = ob-oa;

          return result;
        });
        this.$forceUpdate();
      },
      confirmUpdateCount(item){
        if(parseFloat(item.leftCount)- parseFloat(this.eidtItemCount) <0) {
          Dialog.confirm({
            title: '确认修改',
            message:
              '当前数量已超出，确认提交？',
          })
          .then(() => {
            // on confirm
            item.submitCount = this.eidtItemCount;
            item.editing = false;
            this.$forceUpdate();
          })
        }
        else{
          item.submitCount = this.eidtItemCount;
          item.editing = false;
        }
        

        this.$forceUpdate();
      },
      cancelUpdateCount(item){
        item.editing = false;
        this.$forceUpdate();
      },
      selectItem(item){
        this.list.forEach(o=>{
          delete o.select;
        });
        
        item.select = 'select';

        this.selectedItem = item;

        //如果输入得品号与当前相同,更新剩余数量
        if(this.productId == item.productId){
          this.count = Math.max(0,parseFloat(item.leftCount)  - parseFloat(item.submitCount )  ) ;
        }

        this.$forceUpdate();
      },
      getDetail(){
        var that= this;
        if(this.supplier.id == null || this.supplier.id == '')
          return;

        getDetail(this.supplier.id).then(res=>{
          that.list = res.data;
          that.list.forEach(i=>{
            i.submitCount = 0;
            i.editing = false;
            i.select = null;
          })
        });
      },
      addCount(){
        if(this.list.length == 0 || !this.selectedItem){
          return;
        }

        if(this.selectedItem.productId != this.productId){
          Toast('当前选中品号不符!');
          return;
        }

        if(parseFloat(this.selectedItem.leftCount)- parseFloat(this.selectedItem.submitCount) - parseFloat(this.count) <0) {
          Dialog.confirm({
            title: '确认修改',
            message:
              '当前数量已超出，确认提交？',
          })
          .then(() => {
            // on confirm
           
            this.selectedItem.scaned = true;
            this.selectedItem.submitCount = parseFloat(this.selectedItem.submitCount) + parseFloat( this.count) ;
            this.productId = '';
            this.productName = '';
            this.count = null;
            this.eidtItemCount = 0;
            this.selectedItem = null;
            this.list.forEach(o=>{
              delete o.select;
            });
        
            this.$forceUpdate();
          })
        }
        else{
          this.selectedItem.scaned = true;
          this.selectedItem.submitCount = parseFloat(this.selectedItem.submitCount) + parseFloat( this.count) ;
          this.productId = '';
          this.productName = '';
          this.count = null;
          this.eidtItemCount = 0;
          this.selectedItem = null;
          this.list.forEach(o=>{
            delete o.select;
          });
        
          this.$forceUpdate();
        }

      },
      updateCount(item){
        if(!item.scaned){
          Toast('必须先扫码才能修改!');
          return;
        }

        item.editing = true;
        this.eidtItemCount = item.submitCount;

        this.$forceUpdate();
      },
      submit(){
        if(this.list.length == 0) return;

        var data = {
          supplyName: this.list[0].supplyName,
          supplyContactorName: this.list[0].supplyContactorName,
          departmentCode:this.list[0].departmentCode,
          projectName:this.list[0].projectName,
          back:this.list[0].back,
        }

        data.details = [];
        this.list.forEach(o=>{
          if(o.scaned == true && parseFloat(o.submitCount) > 0)
          
          data.details.push({
            orderId:o.orderId,
            index:o.index,
            productNo:o.productId,
            productName:o.productName,
            unit:o.unit,
            spec:o.spec,
            count:parseFloat(o.submitCount)
          })
        })

        submit(data).then(res=>{
          if(res.code == 200){
            Toast('操作成功!');
            this.supplier = {
              name:'',
              id:null
            };
            this.initialData();
          }
          else{
            Toast('操作失败,'+ res.message);
          }
        })
      },
      async scanSupplier(){
        
          if(!qywxUtil.isReady){
            Toast.loading({
              message: '系统加载中...',
              forbidClick: true,
              duration:0
            });

            Toast.clear();
          }

          var scanResult = await this.$sysUtil.scan();
          var suppliers = (await getSuppliers(scanResult)).data;

          if(suppliers.length == 1){
            this.updateSupplier({
              id:suppliers[0].id,
              name:suppliers[0].name
            })
          }
      },
      searchProduct(){
        if(this.supplier.id == '' || !this.supplier.id){
          Toast('请先选择供应商!');
          return;
        }


        this.productId = this.productId.split('|')[0];
        this.initialProductItemInfo();
      },
      async scanProduct(){
        if(this.supplier.id == '' || !this.supplier.id){
          Toast('请先选择供应商!');
          return;
        }

        var scanResult = await this.$sysUtil.scan();

        this.productId = scanResult.split('|')[0];
        this.initialProductItemInfo();
      },
      goHome(){
        this.$router.push({
            path:'/home',
            query:{
              active:1
            }
          });
      }
    }
  }; 
  </script>
  
<style scoped>
.select{
  border:1px solid rgb(255, 56, 30)
}

.content{
  font-size:14px;
  color:#323233
}
</style>

<style lang="less" scoped>
.van-field__label{
  width:3.2em !important;
}
</style>
